export default __webpack_public_path__ + "assets/863cd94e65760b27b1ee3e9a0ded7fe5.jpg";